import { render } from "./ListePortARisquePage.vue?vue&type=template&id=792ff4de&ts=true"
import script from "./ListePortARisquePage.vue?vue&type=script&lang=ts"
export * from "./ListePortARisquePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__